import axios from 'axios';
import apiConfig from '../../api.config';

export default function deletePoliceERTZFile({ hotelId }) {
  const {
    host,
    URIs: { policeReport, policeReportDeleteERTZFile },
  } = apiConfig;

  const uri = `${host}${policeReport}/${policeReportDeleteERTZFile.replace(':hotelId', hotelId)}`;

  return axios
    .delete(uri, null, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(res => {
      return res.data;
    });
}
